module.exports = __webpack_public_path__ + "img/icon-cake.aa2f1401.svg";